(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-page"]) return;
  try {
    
(function () {
  function initStoryPage(root) {
    if (!root || root.getAttribute('data-st-ready') === '1') return;
    root.setAttribute('data-st-ready', '1');

    var revealEls = root.querySelectorAll('[data-reveal]');
    function revealAll() {
      for (var i = 0; i < revealEls.length; i++) revealEls[i].classList.add('is-revealed');
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll();
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-revealed');
            io.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });
      for (var r = 0; r < revealEls.length; r++) io.observe(revealEls[r]);
      setTimeout(revealAll, 4000);
    } else {
      revealAll();
    }
  }

  function initAll() {
    var pages = document.querySelectorAll('.story-page');
    for (var i = 0; i < pages.length; i++) initStoryPage(pages[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.story-page');
    if (!root && event.target.classList && event.target.classList.contains('story-page')) root = event.target;
    if (root) {
      root.removeAttribute('data-st-ready');
      initStoryPage(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-page"]) return;
  try {
    
(function () {
  var SECTION_IDS = ['s1', 'sBenefits', 's2', 's3', 's4', 's5', 's6'];
  var THRESHOLD = 140;

  function initSciencePage(root) {
    if (!root || root.getAttribute('data-sp-ready') === '1') return;
    root.setAttribute('data-sp-ready', '1');

    var links = root.querySelectorAll('.sp-nav a[href^="#"]');

    function spy() {
      var current = SECTION_IDS[0];
      for (var i = 0; i < SECTION_IDS.length; i++) {
        var el = document.getElementById(SECTION_IDS[i]);
        if (el && el.getBoundingClientRect().top <= THRESHOLD) current = SECTION_IDS[i];
      }
      for (var j = 0; j < links.length; j++) {
        var href = links[j].getAttribute('href');
        var id = href ? href.replace('#', '') : '';
        if (id === current) links[j].classList.add('is-active');
        else links[j].classList.remove('is-active');
      }
    }

    window.addEventListener('scroll', spy, { passive: true });
    spy();

    for (var k = 0; k < links.length; k++) {
      links[k].addEventListener('click', function (e) {
        var href = this.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var revealEls = root.querySelectorAll('[data-reveal]');
    function revealAll() {
      for (var i = 0; i < revealEls.length; i++) revealEls[i].classList.add('is-revealed');
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll();
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-revealed');
            io.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });
      for (var r = 0; r < revealEls.length; r++) io.observe(revealEls[r]);
      setTimeout(revealAll, 4000);
    } else {
      revealAll();
    }
  }

  function initAll() {
    var pages = document.querySelectorAll('.science-page');
    for (var i = 0; i < pages.length; i++) initSciencePage(pages[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.science-page');
    if (!root && event.target.classList && event.target.classList.contains('science-page')) root = event.target;
    if (root) {
      root.removeAttribute('data-sp-ready');
      initSciencePage(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
